export const headerScroll = () => {
  const header = document.getElementById("header");
  const topbar = header.querySelector(".topbar");
  const badge = document.querySelector(".site-badge");
  const nav = header.querySelector(".navbar__nav"); // navbar do klasy

  if (!header || !topbar || !badge || !nav) return;

  let lastScrollTop = 0;
  const topbarHeight = topbar.offsetHeight;
  const OFFSET = 80;

  const hideBadge = () => {
    badge.style.transform = `translate(-50%, -${topbarHeight}px)`;
    badge.style.opacity = "0";
  };

  const showBadge = () => {
    badge.style.transform = `translate(-50%, 0)`;
    badge.style.opacity = "1";
  };

  const showHeader = () => {
    header.style.transform = "translateY(0)";
    if (window.innerWidth < 1200) showBadge();
  };

  const hideTopbar = () => {
    header.style.transform = `translateY(-${topbarHeight}px)`;
    if (window.innerWidth < 1200) hideBadge();
  };

  window.addEventListener("scroll", () => {
    const st = window.pageYOffset || document.documentElement.scrollTop;

    if (st > 0) {
      header.classList.add("is-scrolled");
      nav.classList.add("header-is-scrolled");
    } else {
      header.classList.remove("is-scrolled");
      nav.classList.remove("header-is-scrolled");
    }

    if (st === 0) {
      showHeader();
      lastScrollTop = 0;
      return;
    }

    if (st > lastScrollTop && st > OFFSET) {
      hideTopbar();
    } else if (st < lastScrollTop) {
      showHeader();
    }

    lastScrollTop = st;
  });

  window.addEventListener("resize", () => {
    if (window.innerWidth >= 1200) {
      badge.style.transform = "translateY(-50%)";
      badge.style.opacity = "1";
    }
  });
};
